import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

export default function KVKK() {
  return (
    <div className="min-h-screen px-4 py-8" data-testid="kvkk-page">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-8">
          <Link 
            to="/register" 
            className="text-[#4DFFFF] hover:text-[#4DFFFF]/80 transition-colors"
          >
            <ArrowLeft className="w-5 h-5" />
          </Link>
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-[#4DFFFF]/20 flex items-center justify-center">
              <FileText className="w-5 h-5 text-[#4DFFFF]" />
            </div>
            <h1 className="text-xl font-bold font-['Barlow_Condensed'] uppercase tracking-wider text-white">
              KVKK Aydınlatma Metni
            </h1>
          </div>
        </div>

        {/* Content */}
        <div className="glass-card p-6 space-y-6 text-[#B1C1C1]">
          <section>
            <h2 className="text-lg font-bold text-white mb-3">1. Veri Sorumlusu</h2>
            <p>
              KahveLigi uygulaması ("Platform") olarak kişisel verilerinizin güvenliği konusunda 
              6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında veri sorumlusu 
              sıfatıyla hareket etmekteyiz.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-3">2. İşlenen Kişisel Veriler</h2>
            <p className="mb-2">Platform tarafından aşağıdaki kişisel veriler işlenmektedir:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li><strong>Kimlik Bilgileri:</strong> Ad, soyad, kullanıcı adı</li>
              <li><strong>İletişim Bilgileri:</strong> E-posta adresi</li>
              <li><strong>Hesap Bilgileri:</strong> Şifre (hashlenmiş), profil fotoğrafı</li>
              <li><strong>Kullanım Verileri:</strong> Oyun skorları, lig bilgileri, istatistikler</li>
              <li><strong>Teknik Veriler:</strong> IP adresi, tarayıcı bilgisi, cihaz bilgisi</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-3">3. Kişisel Verilerin İşlenme Amaçları</h2>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Platform üyeliğinin oluşturulması ve yönetimi</li>
              <li>Kullanıcı hesabının güvenliğinin sağlanması</li>
              <li>Oyun ve lig hizmetlerinin sunulması</li>
              <li>İstatistik ve analiz çalışmalarının yapılması</li>
              <li>Kullanıcı deneyiminin iyileştirilmesi</li>
              <li>Yasal yükümlülüklerin yerine getirilmesi</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-3">4. Kişisel Verilerin Aktarımı</h2>
            <p>
              Kişisel verileriniz, yasal zorunluluklar ve/veya hizmet sağlayıcılarımızla 
              (bulut hizmetleri, analitik araçları) paylaşılabilir. Verileriniz yurt dışına 
              aktarılabilir ve bu durumda KVKK'nın öngördüğü güvenlik önlemleri alınır.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-3">5. Kişisel Verilerin Saklanma Süresi</h2>
            <p>
              Kişisel verileriniz, işleme amaçlarının gerektirdiği süre boyunca ve yasal 
              saklama sürelerince muhafaza edilir. Hesabınızı sildiğinizde verileriniz 
              yasal zorunluluklar dışında silinir.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-3">6. Veri Sahibinin Hakları</h2>
            <p className="mb-2">KVKK'nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:</p>
            <ul className="list-disc list-inside space-y-1 ml-4">
              <li>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
              <li>İşlenmişse buna ilişkin bilgi talep etme</li>
              <li>İşlenme amacını ve amacına uygun kullanılıp kullanılmadığını öğrenme</li>
              <li>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri bilme</li>
              <li>Eksik veya yanlış işlenmişse düzeltilmesini isteme</li>
              <li>KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde silinmesini isteme</li>
              <li>İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</li>
              <li>Kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız hâlinde zararın giderilmesini talep etme</li>
            </ul>
          </section>

          <section>
            <h2 className="text-lg font-bold text-white mb-3">7. İletişim</h2>
            <p>
              KVKK kapsamındaki haklarınızı kullanmak için Ayarlar sayfasından bizimle 
              iletişime geçebilirsiniz.
            </p>
          </section>

          <section className="pt-4 border-t border-white/10">
            <p className="text-sm text-[#64748B]">
              Son güncelleme: Ocak 2025
            </p>
          </section>
        </div>

        {/* Back Button */}
        <div className="mt-6 text-center">
          <Link 
            to="/register" 
            className="inline-flex items-center gap-2 text-[#4DFFFF] hover:underline"
          >
            <ArrowLeft className="w-4 h-4" />
            Kayıt sayfasına dön
          </Link>
        </div>
      </div>
    </div>
  );
}
